module.exports = __webpack_public_path__ + "static/media/dots.768f78b1.svg";